import useGames from 'utils/hooks/queries/games/useGames'

export function useGamesFromSlugs(gameSlugs: { slug: string }[]) {
  const { data: games } = useGames()

  return gameSlugs.map((gameInCategory) => {
    const game = games![gameInCategory.slug]

    return { ...gameInCategory, ...game }
  })
}
